import React from "react";
import "./SoftwareRegistry.css";

const SoftwareRegistry = () => {

  return (
    <div>
      <div id="software-registry">
        <div className="container">
          <div className="section-title">
            {/* <h2>Цифровой двойник сети Hadal</h2>
            <h3>Документация</h3> */}
                  
                    <p>Программное обеспечение «Цифровой двойник сети Hadal» –
                        платформа позволяющая снизить риски простоя бизнеса, вызванные нарушениями работы сетевой инфраструктуры.
                    </p>
          </div>
              
          <div className="row">
            {/* Left Column - Documentation and Features */}
            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="card-icon">
                    <i className="fa fa-book"></i>
                  </div>
                  <h3>Функциональные характеристики</h3>
                  <p>Программное обеспечение «Цифровой двойник сети Hadal»
                        предназначено для автоматического документирования, постоянного контроля и анализа
                        изменений конфигураций и операционного состояния сетевого оборудования, находящегося в
                        корпоративной сети передачи данных предприятий.
                    </p>
                  <div className="features-section">
                    <h4>Задачи, решаемые с цифровым двойником сети Hadal</h4>
                    <ul>
                      <li>Сокращение времени незапланированных простоев бизнеса в том числе, вызванных ошибочными настройками оборудования, а также сокращение времени на их поиск и устранение;
                      </li>
                      <li>Автоматизация процессов документирования сетевой инфраструктуры;</li>
                      <li>Повышение общей устойчивости и защищенности сетевой инфраструктуры от киберугроз;
                      </li>
                      <li> Сопоставление возможностей сетевой и ИТ инфраструктуры уровню поставленных перед ней бизнес задач (создание паспорта-спецификации на инфраструктуру).

                      </li>
                    </ul>

                    <h4>Программное обеспечение предназначено для</h4>
                    <ul>
                      <li>
                          Автоматического сбора данных о конфигурациях и операционном состоянии сетевого оборудования (коммутаторы, маршрутизаторы, межсетевые экраны и др.) через защищенные протоколы (SSH, Telnet, API и др.);
                      </li>
                      <li>Построения многоуровневых карт сетевой инфраструктуры;</li>
                      <li>Исторического анализа состояний оборудования в сетевой инфраструктуре.</li>
                    </ul>
                  </div>
                  <p>Программное обеспечение предоставляет Веб-интерфейс для анализа данных о сетевой инфраструктуре.</p>
                </div>
              </div>
            </div>

            {/* Right Column - Documentation Links and Contacts */}
            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="card-icon">
                    <i className="fa fa-book-open"></i>
                  </div>
                  <h3>Документация</h3>
                  <div className="documentation-list">
                    <div>
                      <i className="fa fa-file"></i>
                      <a href="/docs/functional-characteristics.pdf">
                        Функциональные характеристики ПО 
                        «Цифровой двойник сети Hadal»
                      </a>
                    </div>
                    <div>
                      <i className="fa fa-file"></i>
                      <a href="/docs/lifecycle-processes.pdf">
                        Описание процессов, обеспечивающих поддержание
                        жизненного цикла ПО «Цифровой двойник сети Hadal»
                      </a>
                    </div>
                    <div>
                      <i className="fa fa-file"></i>
                      <a href="/docs/installation-guide.pdf">
                      Инструкция по установке экземпляра
                      ПО «Цифровой двойник сети Hadal»
                      </a>
                    </div>
                    <div>
                      <i className="fa fa-file"></i>
                      <a href="/docs/user-manual.pdf">
                      Руководство пользователя
                      ПО «Цифровой двойник сети Hadal»
                      </a>
                    </div>
                    <div>
                      <i className="fa fa-file"></i>
                      <a href="/docs/user-agreement.pdf">
                      Пользовательское соглашение
                      ПО «Цифровой двойник сети Hadal»
                      </a>
                    </div>
                  </div>

                  <div className="pricing-section">
                    <h3>Расчёт стоимости для юридических лиц</h3>
                    <p>
                      Стоимость программного обеспечения рассчитывается индивидуально. 
                      Для точного расчета стоимости оставьте заявку нашим менеджерам по контактным данным ниже.
                    </p>
                    <div className="contact-info">
                      <p>
                        <i className="fa fa-envelope"></i>
                        <a href="mailto:info@hadal.tech">info@hadal.tech</a>
                      </p>
                      <p>
                        <i className="fa fa-phone"></i>
                        <a href="tel:+7XXXXXXXXXX">+7 (985) 255-79-70</a>
                      </p>
                    </div>
                  </div>
                  <div className="support-section">
                      <h3>Техническая поддержка</h3>
                      <p>
                        Связаться со службой технической поддержки можно по электронной почте{" "}
                        <a href="mailto:help@hadal.tech">help@hadal.tech</a>
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Hadal Project, All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default SoftwareRegistry; 